import ability from './ability'

export const canNavigate = to => to.matched.some((route) => {
  const action = route.meta.action || 'read'
  const resource = route.meta.resource

  if (!resource) {
    return true
  }

  return ability.can(action, resource)
})

export const _ = undefined
